export default [
    {
        "id": "search-advanced",
        "plugin": "NewPromo",
        "pluginId": 1,
        "name": "new-product",
        "predefinedPlugin": {
            "plugin": "manufacturer",
            "pluginId": 7,
            "name": "manufacturer-brand"
        },
        "html": require('./search-advanced/html').default,
        "js": require('./search-advanced/js').default,
        "minJs": require('./search-advanced/minJs').default,
        "css": require('./search-advanced/css').default,
        "cssTablet": require('./search-advanced/cssTablet').default,
        "cssMobile": require('./search-advanced/cssMobile').default,
        "scss": require('./search-advanced/scss').default,
        "scssTablet": require('./search-advanced/scssTablet').default,
        "scssMobile": require('./search-advanced/scssMobile').default
    }
]